// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import DemocraticRepublicCongo from '../_raw/flag/icon_flag_democratic_republic_congo.png';

export default () => <img src={DemocraticRepublicCongo} alt="DemocraticRepublicCongo" />;
